import store from "../../store"

export default function auth ({ next }) {
    if (store.getters.GET_TOKEN) {
        return next()
    }
    return next({ name: 'login' })
}
